import { UserSettings, SetUserSettingType } from './@types'

const isClient = typeof window !== 'undefined'

export const getUserSettings = (): UserSettings => {
  try {
    return (
      isClient &&
      JSON?.parse(window?.localStorage?.getItem('userSettings') || '""')
    )
  } catch (e) {
    return JSON?.parse('""')
  }
}

export const setUserSetting = (
  type: SetUserSettingType,
  value,
): UserSettings | undefined => {
  if (isClient && window?.localStorage) {
    const userSettings: UserSettings = getUserSettings()
    let newUserSettings: UserSettings

    switch (type) {
      case 'spaceCollection':
        newUserSettings = {
          ...userSettings,
          spaceCollections: {
            ...userSettings?.spaceCollections,
            [value?.id]: {
              isExpanded: value?.isExpanded,
              name: value?.name,
            },
          },
        }
        break

      case 'appearance':
        newUserSettings = {
          ...userSettings,
          appearance: {
            ...userSettings?.appearance,
            ...value,
          },
        }
        break

      default:
        return undefined
    }

    window?.localStorage?.setItem(
      'userSettings',
      JSON?.stringify(newUserSettings),
    )
    return newUserSettings
  }
}
